<yt-fw-default-update-buttons #defaultUpdateButtons>
    <div class="btn-group mr-2" >
        <button class="btn btn-outline-primary" type="button" (click)="UpdateKomitentPoPib()" container="body"
            ngbTooltip="{{'KOMITENT.AZURIRAJKOMITENTANBS.TOOLTIP' | translate }}" placement="bottom">
            <i class="fas fa-file-alt"></i>
            <span style="padding-left: 5px;" translate="KOMITENT.AZURIRAJKOMITENTNBS.SINGULAR"></span>
        </button>
    </div>
</yt-fw-default-update-buttons>

<yt-komitent-update #baseUpdate></yt-komitent-update>
<div class="row">
  <div class="col-md-12">
    <div class="btn-group float-right">
      <button type="button" class="btn btn-outline-primary" (click)="Save()" [disabled]="saveDisabled"><span class="fa fa-fa fa-save"></span> Sačuvaj</button>
      <button type="button" class="btn btn-outline-primary" (click)="Reset()"><span class="fa fa-fa fa-undo"></span> Odustani</button>
    </div>
  </div>
</div>
